import { render, staticRenderFns } from "./InitialProposalSettings.vue?vue&type=template&id=38e5fca6"
import script from "./InitialProposalSettings.vue?vue&type=script&lang=js"
export * from "./InitialProposalSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports